<style/styles: any>
  .imageContainer {
    display: flex;
    justify-content: center;
  }

  .imageContainer img {
    width: 280px;
    height: 280px;
  }
</style>

export interface Input {
  content: Marko.Body;
}

<div class=styles.imageContainer style={ "grid-area": "image" }>
  <${input.content}/>
</div>
